import { LinkTarget, LinkType } from '@aurora/shared-generated/types/graphql-schema-types';
import type { LinkProps } from '../../components/community/Navbar/types';
import type {
  ExternalMenuLink,
  InternalMenuLink,
  MenuLinkItem
} from '../../components/community/NavbarLink/NavbarLink';
import { MenuLinkType } from '../../components/community/NavbarLink/NavbarLink';
import type { I18n } from '@aurora/shared-types/texts';

function linkPropsToExternalMenuLinkItem(
  link: LinkProps,
  i18n: I18n<unknown, unknown>
): ExternalMenuLink {
  return {
    type: MenuLinkType.EXTERNAL,
    contents: () => i18n.formatMessage(link.linkLabel),
    url: link.url,
    target: link.openInNewTab ? LinkTarget.Blank : LinkTarget.Self,
    id: link.id
  };
}

function linkPropsToInternalMenuLinkItem(
  link: LinkProps,
  i18n: I18n<unknown, unknown>
): InternalMenuLink {
  return {
    type: MenuLinkType.INTERNAL,
    contents: () => i18n.formatMessage(link.linkLabel),
    route: link.goesToPage,
    id: link.id
  };
}

export function linkPropsToMenuLinkItem(
  link: LinkProps,
  i18n: I18n<unknown, unknown>
): MenuLinkItem {
  switch (link.linkType) {
    case LinkType.External: {
      return linkPropsToExternalMenuLinkItem(link, i18n);
    }

    case LinkType.Internal: {
      return linkPropsToInternalMenuLinkItem(link, i18n);
    }

    default: {
      return null;
    }
  }
}

export function linkPropsToMenuLinkItems(
  links: LinkProps[],
  i18n: I18n<unknown, unknown>
): MenuLinkItem[] {
  return (
    links
      ?.map(link => ({
        ...linkPropsToMenuLinkItem(link, i18n),
        menuLinks:
          link.children && link.children.length > 0
            ? link.children.map(child => linkPropsToMenuLinkItem(child, i18n))
            : null
      }))
      .filter(link => !!link) ?? []
  );
}
